import gsap from 'gsap'
import { IndexKv } from './IndexKv'

export class Loading {
  constructor() {
    this.kv = document.getElementById('js-index-kv')
    this.page = document.getElementById('page')
    this.loading = document.getElementById('js-loading')
    this.fixedKv = document.getElementById('js-index-fixed-kv')
    this.header = document.getElementById('js-header')
    this.body = document.body
    this.indexKv = new IndexKv()

    const isOpening = this.body.classList.contains('is-opening')

    document.addEventListener('DOMContentLoaded', () => {
      if (!isOpening) {
        gsap.to(this.page, { opacity: 1, duration: 1 })
      } else {
        gsap.set(this.page, { opacity: 1 })
      }
    })

    // 要素が存在しない場合の対策（nullチェック）
    const loadingElms = {
      videoWrap: this.loading?.querySelector('.p-index_loading__video') || null,
      video: this.loading?.querySelector('video') || null,
    }

    const kvElms = {
      titleMain: this.kv?.querySelector('.p-index_kv__title .main') || null,
      titleSub: this.kv?.querySelector('.p-index_kv__title .sub') || null,
      video: this.fixedKv?.querySelector('video') || null,
    }

    // 要素が存在する場合のみ初期状態セット
    if (kvElms.titleMain) {
      gsap.set(kvElms.titleMain, { scale: 0, opacity: 0 })
    }
    if (kvElms.titleSub) {
      gsap.set(kvElms.titleSub, { scale: 0, opacity: 0 })
    }

    if (isOpening) {
      this.openingFull(kvElms, loadingElms)
    } else {
      this.openingShort(kvElms)
    }
  }

  openingFull(kvElms, loadingElms) {
    this.body.classList.add('is-loading', 'is-fixed')

    const copy = this.loading?.querySelector('.p-index_loading__copy')
    const bg = this.loading?.querySelector('.p-index_loading__bg')
    const video = loadingElms.video
    const fixedVideo = kvElms.video

    if (loadingElms.videoWrap) {
      gsap.set(loadingElms.videoWrap, { opacity: 0 })
    }
    if (copy) {
      gsap.set(copy, { opacity: 0 })
    }
    if (bg) {
      gsap.set(bg, { opacity: 1 })
    }

    const tl = gsap
      .timeline({ paused: true })
      .to(
        this.loading,
        {
          duration: 0.3,
          onStart: () => this.indexKv.initLoading(),
        },
        0
      )
      .to(
        loadingElms,
        {
          opacity: 1,
          duration: 0.8,
        },
        '<'
      )
      .to(
        copy,
        {
          opacity: 1,
          duration: 1,
        },
        '+=0.1'
      )
      .to(
        [copy, bg],
        {
          opacity: 0,
          duration: 1,
        },
        '+=1'
      )
      // フェードアウト完了後に動画表示＆再生開始
      .to(
        {},
        {
          duration: 0,
          onComplete: () => {
            if (video) {
              video.muted = true
              video.playsInline = true
              video.setAttribute('preload', 'auto')
              video.load()
              video.currentTime = 0
              video.play().catch((e) => console.warn('Video play failed:', e))
            }
            if (loadingElms.videoWrap) {
              gsap.set(loadingElms.videoWrap, { opacity: 1 })
            }
          },
        }
      )
      // 動画再生終了を監視し、終わったらすぐにfixedKv動画再生へ切り替え
      .to(
        {},
        {
          duration: 0,
          onComplete: () => {
            if (!video || !fixedVideo) return

            video.onended = () => {
              fixedVideo.muted = true
              fixedVideo.playsInline = true
              fixedVideo.setAttribute('preload', 'auto')
              fixedVideo.load()
              fixedVideo.currentTime = 0

              fixedVideo.addEventListener(
                'canplaythrough',
                () => {
                  fixedVideo.play().catch((e) => console.warn('Fixed KV video play failed:', e))

                  // ぱっと切り替え（フェードなし）
                  gsap.set(fixedVideo, { opacity: 1 })
                  gsap.set(loadingElms.videoWrap, { opacity: 0 })
                  gsap.to(this.loading, {
                    opacity: 0,
                    duration: 0,
                    onComplete: () => {
                      setTimeout(() => {
                        this.loading.style.display = 'none'
                        this.body.classList.remove('is-fixed')
                        this.body.classList.remove('is-loading')
                      }, 500)
                    },
                  })

                  this.indexKv.initKv()
                  this.body.classList.add('is-loading-end')
                },
                { once: true }
              )
            }
          },
        },
        '>'
      )

    window.addEventListener('load', () => {
      tl.play()
    })
  }

  openingShort(kvElms) {
    gsap.set(this.loading, { display: 'none' })

    const tl = gsap.timeline()

    window.addEventListener('load', () => {
      tl.to(
        this.kv,
        {
          duration: 1.2,
          onStart: () => {
            this.indexKv.initKv(2)
          },
        },
        0
      ).to(
        this.page,
        {
          onComplete: () => {
            this.body.classList.add('is-loading-end')
          },
        },
        '<'
      )
    })
  }
}
